if (!customElements.get('product-details-modal')) {
  customElements.define(
    'product-details-modal',
    class ProductDetailsModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('[data-details-dialog]');
        this.openButton = this.querySelector('[data-details-open]');
        this.closeButton = this.querySelector('[data-details-close]');
        this.handlePopState = this.handlePopState.bind(this);
      }

      connectedCallback() {
        if (!this.dialog || !this.openButton) return;

        this.openButton.addEventListener('click', () => this.open());
        this.closeButton?.addEventListener('click', () => this.requestClose());

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.requestClose();
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.requestClose();
        });

        window.addEventListener('popstate', this.handlePopState);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.handlePopState);
      }

      open() {
        if (this.dialog.open) return;

        this.dialog.classList.remove('product-details-modal--closing');
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
        history.pushState({ productDetailsModal: this.dialog.id }, '', window.location.href);
        this.hasHistoryEntry = true;
      }

      requestClose() {
        if (this.hasHistoryEntry && history.state?.productDetailsModal === this.dialog.id) {
          history.back();
          return;
        }

        this.close();
      }

      handlePopState() {
        if (!this.dialog.open) return;
        this.hasHistoryEntry = false;
        this.close();
      }

      close() {
        if (!this.dialog.open || this.isClosing) return;
        this.isClosing = true;
        this.dialog.classList.add('product-details-modal--closing');

        window.setTimeout(() => {
          this.dialog.close();
          this.dialog.classList.remove('product-details-modal--closing');
          document.body.classList.remove('overflow-hidden');
          this.openButton?.focus({ preventScroll: true });
          this.isClosing = false;
        }, 90);
      }
    }
  );
}
